import { TermsAcdConditionsView } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/steps/termsAndConditions/TermsAndConditionsView'
import React from 'react'

import settings from 'src/config/settings'

interface TermsDocumentProps {
  attachmentUID: string | null
}

export const TermsDocument: React.FC<TermsDocumentProps> = ({ attachmentUID }) => {
  if (!attachmentUID) return null

  return (
    <TermsAcdConditionsView
      content={`${settings.httpsServices.onboarding}/api/v0/bp-terms-condition/${attachmentUID}`}
      contentType="pdf"
    />
  )
}
